import {Component} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import {FormWrapperComponent} from '../../components/form-wrapper/form-wrapper.component';

@Component({
  selector: 'app-not-found',
  imports: [FormWrapperComponent, TranslatePipe],
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.scss',
})
export class NotFoundComponent {

}
